import React from 'react';
import { Container, } from 'react-bootstrap';
import { siteData } from '../data/siteData';
import '../App.css';

const WorkShowcase = () => {
  return (
    <section className="workshow-section" style={{padding: '4rem 0', background: '#FFF9F9'}}>
      <Container>
        <h2 style={{textAlign: 'center', fontWeight: 'bold', marginBottom: '0.6rem', fontSize: '2.4rem', direction:'rtl'}}>
          معرض الأعمال
        </h2>
        <p style={{textAlign: 'center', color: '#888', marginBottom: '2.4rem', direction:'rtl'}}>
          شاهد جودة منتجاتنا وجمالها في غرف نوم حقيقية. استلهم من عملائنا السعداء.
        </p>
        <div className="workshow-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem'}}>
          {siteData.worksShowcase.map((work, idx) => (
            <div key={idx} className="workshow-card" style={{position: 'relative', borderRadius: '18px', boxShadow: '0 5px 20px rgba(0,0,0,0.11)', overflow: 'hidden', background: '#fff'}}>
              <img src={work.image} alt={`جودة أفرشة فاخرة في غرفة نوم – معرض أعمال سفيان للأفرشة رقم ${idx + 1} | Découverte d’un lit de luxe chez Soufiane Literie – Réalisation n°${idx + 1} | Luxury bedroom bedding showcase by Soufiane Bedding – Work n°${idx + 1}`} style={{width: '100%', height: '220px', objectFit: 'cover', aspectRatio: '1.4/1'}} />
              <div style={{position: 'absolute', bottom: '0', right: '0', left: '0', background: 'linear-gradient(0deg, rgba(0,0,0,0.42) 62%, rgba(0,0,0,0.14) 94%, transparent)', color: 'white', padding: '1.2rem 1.2rem 0.2rem 0.6rem', fontWeight: 'bold', letterSpacing: '1px', fontSize: '1.13rem', borderRadius: '0 0 18px 18px', textShadow: '0 1px 6px #0007', textAlign: 'right'}}>{work.title}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default WorkShowcase;
